import React from "react";
import Navbarrr from "../navbar/navbarrr";
import "./tours.css";

function Tours() {
  return (
    <div className="toursbckkk">
      <div>
        <img alt="abc" src="images/tour1.jpg" className="toursimgggggggg"></img>
        <Navbarrr />
        <p className="tcrxrrrrtt">Nlsa Society Tours</p>
        <h1 className="tcrxrrrrttt">
          Nlsa Society Arrange All The Tours <br />
          of Nlsa and Lims
        </h1>
      </div>
      <div>
      
      </div>
    </div>
  );
}

export default Tours;
